<template>
  <div>
    <ChatroomFilter v-on:on-search="onSearch" :categories="categories" :groups="groups" :levels="levels"></ChatroomFilter>
    <ChatroomList v-on:add-tag="addTag" v-on:add-group="addGroup" ref="ChatroomList" v-bind="filter" :categories="categories" :groups="groups" :levels="levels"></ChatroomList>
  </div>
</template>

<script>
import '../config/global'
import ChatroomFilter from './ChatroomFilter'
import ChatroomList from './ChatroomList'

const axios = require('axios')
export default {
  name: 'ChatroomManage',
  components: {ChatroomList, ChatroomFilter},
  data () {
    return {
      getTagsUrlPostfix: 'get_tags',
      getGroupsPostfix: 'get_groups',
      getLevelsPostfix: 'UChatroom/get_levels',
      categories: [],
      groups: [],
      levels: [],
      filter: {
        selectedTagList: [],
        searchChatroomNickname: '',
        searchOwnerNickname: '',
        searchOwnerUsername: ''
      }
    }
  },
  computed: {
    getTagsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getTagsUrlPostfix
    },
    getGroupsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getGroupsPostfix
    },
    getLevelsUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getLevelsPostfix
    }
  },
  created () {
    this.getGroups()
    this.getLevels()
    this.getTags()
  },
  methods: {
    getTags () {
      axios.post(this.getTagsUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          // console.log(data.data)
          // console.log('data.err_code: ' + data.data.err_code)
          if (data.data.err_code === 0) {
            this.categories = data.data.content.tags
            // console.log(this.category_list)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    getLevels () {
      // console.log('getLevels')
      axios.post(this.getLevelsUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          // console.log(data.data)
          // console.log('data.err_code: ' + data.data.err_code)
          if (data.data.err_code === 0) {
            this.levels = data.data.content.levels
            // console.log(this.levels)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    getGroups () {
      // console.log('getGroups')
      axios.post(this.getGroupsUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          // console.log(data.data)
          // console.log('data.err_code: ' + data.data.err_code)
          if (data.data.err_code === 0) {
            this.groups = data.data.content.groups
            // console.log('getGroups', this.groups)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    onSearch (filter) {
      console.log('onSearch')
      this.filter = filter
      // console.log('filter.selectedTagList', filter.selectedTagList)
      setTimeout(() => {
        this.$refs.ChatroomList.fetch()
      })
    },
    addTag (tag) {
      console.log('addGroup', tag)
      this.getTags()
    },
    addGroup (group) {
      console.log('addGroup', group)
      this.getGroups()
    }
  }
}
</script>
